<template>
  <div v-show="!isLoading">
    <b-modal :id="ModalId" size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" scrollable centered :title="TitleWindow" :visible="!NotOpenByDefault ? true : false"  :ok-disabled="this.disableOkButton"  @ok="this.emitEventOK" @hide="emitEventHide" :cancel-title="$t('Shared.BtnCancel')">
      <Loading v-bind:IsLoading="this.isLoading" />   
  
      <div v-if="isListing" id="AssessmentList">
        <div class="row">
          <div class="card" style="width:100%;">
              <div class="card-body">
                  <MdTitle v-bind:Text="$tc('MdPainAssessmentNotesOutCome.PAssessmenTitle')" />  
                  <div class="row">
                      <div class="col-sm-12 col-md-3">                      
                          <MdButton
                            v-bind:Label="$t('Assessment.AddAssessment')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddAssessment"
                            v-bind:isReadOnly=this.isReadOnly>
                          </MdButton>
                      </div>
                      <div class="col-sm-12 col-md-9 mb-4">
                          <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                              <div class="input-group" dir="ltr">
                                  <input 
                                    type="text" 
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"   
                                     @keyup.enter="SearchAssessment"                            
                                  >
                                  <div class="input-group-append">
                                      <div class="input-group-append">
                                      <MdButton 
                                        v-bind:Name="'btnsearchinput'"
                                        v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'"
                                        v-on:click="SearchAssessment">
                                      </MdButton>
                                  </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>              
              </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="card" style="width:100%;">
              <div class="card-body" style="margin-top:-30px !important;">
                  <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                  <div class="row">
                      <div class="col-md-12">
                      
                       <div>
  
                         <b-col lg="6" class="my-1">
        </b-col>
         <MdTable
            v-bind:refTable="'PainAssesmentTable'"
            ref="PainAssesmentTable" 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"
            v-bind:isReadOnly="isReadOnly"
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:EnabledRowClicked="true"
            v-bind:perPage="perPage"
            :onRowClicked="RowClicked"
            v-bind:pageOptions="pageOptions"
            :editIconEvent="EditAssessment"
            v-bind:VisibleEditIcon="true"
            :deleteIconEvent="RemoveAssessment"
            v-bind:VisibleDeleteIcon="true"
            :onRowSelected="onRowSelected"
            :onFiltered="onFiltered"
            :pageChanged="pageChanged"
            :perPageFunction="PerPageFunction"
            v-bind:userId="UserId"
            v-bind:isPainAssessment="true">
          </MdTable>
       </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
     </div>

     <div v-show="isEditMode" id="AssessmentDetail">
      <div id="ContainerPainAssessment">     
         <MdTitle v-bind:Text="$t('MdPainAssessmentNotesOutCome.ASSESSMENT')" v-bind:isSubtitle="true" v-bind:Name="'T_Assessment'"/>
         <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.WrittenBy')"
                    v-bind:Name="'therapist'"
                    v-bind:isReadOnly="true"
                    v-model="painAssessment.therapistCode">                                     
                </MdEdit>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Date')"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'date'"
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="painAssessment.assessmentDate">                                     
                </MdEdit>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Incident.IncTime')"
                    v-bind:TypeProp="'time'"
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null" 
                    v-bind:Name="'time'"
                    v-model="painAssessment.assessmentTime">                                     
                </MdEdit>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                v-bind:Label="$t('MdPainAssessmentNotesOutCome.PainIntensity')"
                data-field="PainScore"
                v-bind:Options="painIntensityList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'value'"
                v-bind:Model="painAssessment.painIntensity"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownPainScore"
            />
            </b-col>
         </b-row>
         <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('MdPainAssessmentNotesOutCome.PainLocation')"
                    v-bind:TypeProp="'text'" 
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:Name="'Location'"
                    v-model="painAssessment.location"
                    v-bind:Id="'input_location_id'">                                     
                </MdEdit>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('MdPainAssessmentNotesOutCome.PainType')"
                    data-field="Character"
                    v-bind:Options="charactertList"
                    v-bind:FieldDescription="'name'"
                    v-bind:IsDisabled="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="painAssessment.painCharacter"                       
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownCharacter"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Frequency')"
                    data-field="Frequency"
                    v-bind:Options="frequencyList"
                    v-bind:FieldDescription="'name'"
                    v-bind:IsDisabled="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:FieldCode="'value'"
                    v-bind:Model="painAssessment.frequency"                       
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownFrequency"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('MdPainAssessmentNotesOutCome.Duration')"
                    v-bind:TypeProp="'text'" 
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:Name="'Duration'"
                    v-model="painAssessment.duration">                                     
                </MdEdit>
            </b-col>
         </b-row>
         <MdTitle v-bind:Text="$t('MdPainAssessmentNotesOutCome.Interventions')" v-bind:isSubtitle="true" v-bind:Name="'T_Interventions'"/>
         <b-row>
          <b-col md="4" lg="4" sm="12">       
                  <MdCheckListBox2 
                    v-model="painAssessment.interventionList"
                    v-bind:OnChangeProp="OnChangeIntervention"
                    v-bind:Options="interventionList"
                    v-bind:Height="'150px'"
                    v-bind:columnCount="2"
                    :textField="'name'"
                    :valueField="'code'"> 
                  </MdCheckListBox2>
         </b-col>
         </b-row>
         <b-row>       
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('MdPainAssessmentNotesOutCome.OtherInterventions')"
                    v-bind:TypeProp="'text'" 
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:Name="'Other'"
                    v-model="painAssessment.otherIntervention">                                     
                </MdEdit>
            </b-col>
            <!--
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Incident.IncTime')"
                    v-bind:TypeProp="'number'" 
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:Name="'Time'"
                    v-model.number="painAssessment.interventionTime">                                     
                </MdEdit>
            </b-col>
            -->
         </b-row>         
         <MdTitle v-bind:Text="$tc('Shared.Note', 2)" v-bind:isSubtitle="true" v-bind:Name="'T_Notes'"/>
         <b-row>
            <b-col md="12" lg="12" sm="12">
                <MdMemo
                    v-bind:Name="'textarea_notes'"
                    v-bind:Rows="'3'"
                    v-bind:isReadOnly="painAssessment.painAssessment === '' || painAssessment.painAssessment === null"
                    v-bind:MaxRows="'6'"
                    v-bind:MaxLength="'500'"
                    v-model="painAssessment.notes"
                />
            </b-col>
         </b-row>
       </div>

       <b-row class="mt-2">
        <b-col md="12">
            <div class="text-center text-md-right mt-3 container-button">
              <MdButton
              v-bind:Label="$t('Shared.Back')"
              v-bind:ClassProp="'secondary mx-2 btn-login'"
              v-on:click="showListing(true)"
          />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:VariantProp="'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
            />          
            </div>
        </b-col>
    </b-row>
    
     </div>
       
     <template #modal-footer v-if="isEditMode">
      <div class="w-100">       
       
      </div>
    </template>

    <MdPasswordDlg v-if="showSignPassword"
      v-bind:UserId="UserId"
      v-bind:ShowPopup="showSignPassword"
      v-bind:EmployeeCode="this.$store.state.employeeCode"
      @getModalPassword="onModalPasswordResult($event)"
    />
      
     
   </b-modal>  
  </div>
</template>

<script>
import AssessmentService from '@/services/painassessment.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import Loading from '@/components/template/loading/Loading'
import LocalStorage from '@/services/storage.service';
import GlobalService from '@/services/global.service' 
import EnumService from "@/services/enum.service";
import { EventBus } from '@/event-bus.js';

export default {
  name: 'ListingPainAssessment',
  props: {
     ModalId: String,
     PatientCode:String,
     TitleWindow: String,
     outComeCode:String,
     NotOpenByDefault:Boolean,
     ForUsefromMars:Boolean,
     MarsParam:Object,
     RecordId:String
   },
   mixins: [ShowMessage, DBFunctions],
   components: {
      Loading
    },
  data(){
    return{
      UseSelectTableAll:false,
      refTable: 'selectableTablePainAssessment',
      recNo:null,
      isAdd:false,
      UserId:LocalStorage.getUserId(),
      isLoading:true,
        parameter:{
            SearchCriteria:'',
            PageNumber : 1,
            PageSize:0 ,
            RecordId:this.RecordId,           
        }, 
        Header:{}, 
        isReadOnly: false,
        therapistList: [],
        charactertList: EnumService.Characterts,
        frequencyList: EnumService.Frequencys,
        interventionList: EnumService.Interventions,
        painAssessment: {
          therapistCode:"",
          isSigned:false,
          assessmentDate:null,
          assessmentTime:null,
          painIntensity:null,
          location:"",
          painCharacter:"",
          duration:"",
          frequency:"",
          interventionList:[],
          otherIntervention:"",
          interventionTime:null,
          notes:"",
        },
        showSignPassword: false,
        pendingChanges: false,
        clickOK: false,      
        ShowMessageIsEmpty:false,
        isEditMode:false,
        isListing: true,      
        items:[],
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        SelectedRecords:0, 
        perPage: 5,
        filter: null,
        filterOn: [],      
        selected: [], 
        isSelectFirst:false,     
        fields:[
          
          { key: 'assessmentDate', sortable: true, label: this.$t('Shared.Date'), class: 'text-rigth' },
          { key: 'assessmentTime', sortable: true, label: this.$t('Shared.Time'), class: 'text-rigth' },
          {key:'recNo', sortable: true, label: 'RecNo', class: 'hidden' },
          { key: 'painIntensity', sortable: true, label: this.$t('MdPainAssessmentNotesOutCome.PainIntensity'), class: 'text-rigth' },
          { key: 'location', sortable: true, label: this.$t('MdPainAssessmentNotesOutCome.PainLocation'), class: 'text-rigth' },
          { key: 'selected', sortable: true, label: '', class: 'text-rigth hidden' },     
          { key: 'painCharacter', sortable: true, label: this.$t('MdPainAssessmentNotesOutCome.PainType'), class: 'text-rigth' },
          { key: 'frequency', sortable: true, label: this.$t('Shared.Frequency'), class: 'text-rigth' },
          { key: 'duration', sortable: true, label: this.$t('MdPainAssessmentNotesOutCome.Duration'), class: 'text-rigth' },
          { key: 'intervention', sortable: true, label: this.$t('MdPainAssessmentNotesOutCome.Interventions'), class: 'text-rigth' },
          { key: 'otherIntervention', sortable: true, label: this.$t('MdPainAssessmentNotesOutCome.OtherInterventions'), class: 'text-rigth' },
          { key: 'therapistName', sortable: true, label: this.$tc('Shared.Employee',1), class: 'text-rigth' },
        ],
        painIntensityList: [
          {"name":0, "value":0},
          {"name":1, "value":1},
          {"name":2, "value":2},
          {"name":3, "value":3},
          {"name":4, "value":4},
          {"name":5, "value":5},
          {"name":6, "value":6},
          {"name":7, "value":7},
          {"name":8, "value":8},
          {"name":9, "value":9},
          {"name":10, "value":10},
        ],
        NoteOptions:{},
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
  },

  computed: {
    disableOkButton() {
        return this.isEditMode || (this.ForUsefromMars && this.selected.length === 0);
    }
  },

  methods:{

    async getNoteOption(){
      this.NoteOptions = await this.getNoteOptions();   
    },

    getDateTime() { 
         GlobalService.getDateTime()
            .then((response) => {      
               if (response.data) {
                  if (!this.VitalSId) 
                     this.painAssessment.assessmentDate = this.formatterDate(response.data);
                     this.painAssessment.assessmentTime = Utils.formatTimeHm(response.data)
               }  
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
      },

    ChangeDropDownPainScore(item) {
      this.painAssessment.painIntensity = item && item.value ? item.value : ''
    },

    tbodyRowClass(item) { 
      if(item != null){
         if(item.selected){
          return ["b-table-row-selected", "table-active", "cursor-pointer"]
        } else {
          return ["cursor-pointer"]
        }
      }
      },

      processResult(Lote, PainIntensity,Location,PainCharacter,Duration,Intervention,OtherIntervention,Notes) {
        let textResult = "";

        const hasData =
          PainIntensity || Location || PainCharacter || Duration ||
          (Intervention && Intervention.length > 0) || OtherIntervention || Notes;

        if (hasData) {
          textResult += "SCALE RESULTS\n";
          if (PainIntensity) textResult += `Pain Intensity: ${PainIntensity}\n`;
          if (Location) textResult += `Pain Location: ${Location}\n`;
          if (PainCharacter) textResult += `Pain Type: ${PainCharacter}\n`;
          if (Duration) textResult += `Duration: ${Duration}\n`;

          if (Intervention && Intervention.length > 0) {
            let cleanedIntervention = Intervention.replace(/\r\n/g, ", ");
            textResult += `Interventions: ${cleanedIntervention}`;
            if (OtherIntervention) {
              textResult += `, ${OtherIntervention}\n`;
            } else {
              textResult += `\n`;
            }
          } else if (OtherIntervention) {
            textResult += `Other Interventions: ${OtherIntervention}\n`;
          }

          if (Notes) {
            textResult += `Notes: ${Notes}\n`;
          }
        }

        return Lote ? `${textResult}\n` : `${textResult}`;
      },

      getTextResult() {
         let textResult = ''  
         let keys = [];     
         if(this.selected.length > 0){
            var item = this.selected[0];  
            keys = Object.keys(this.items[0]);
            keys.forEach(element => {             
               if(item[element] != '' && item[element] != '0'  && item[element] != null) {  
                  if(element != 'headerId' && element != 'sysDate' && element != 'sysUser' && element != 'recNo' && element != 'titleRecNo' && element != 'selected'){
                    textResult = this.processResult(false, item['painIntensity'],item['location'],item['painCharacter'],item['duration'],item['intervention'],item['otherIntervention'],item['notes'])
                  }                 
               }
               });
               textResult = textResult+"\r\n";
         }
         /* else{
            if (this.items.length > 0) {
            this.items.forEach(item => {
               textResult += this.processResult(true, item['painIntensity'],item['location'],item['painCharacter'],item['duration'],item['intervention'],item['otherIntervention'],item['notes'])
               textResult = textResult + "\r\n";
            });            
         }
         } */
     

         return textResult
      },

    tbodyRowAttr() {
			return {style: 'cursor: pointer'}
		},
    emitEventHide(handled){
        if (this.pendingChanges) {
        handled.preventDefault()
        this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('MdPainAssessmentNotesOutCome.PAssessmenTitle'),
          okTitle: this.$t('Shared.Save'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              this.$emit('getCancel');
              this.ResetProps();
            }
          })		
        } else {
            if(this.clickOK && this.selected.length > 0) {
               if(this.ForUsefromMars){
                  let param = {
                     info:this.getTextResult(),
                     outComeCode:this.outComeCode,
                     MarsParam:this.MarsParam 
                  }
                  this.$emit('getCodeConditionOK', param);
                  this.$emit('input',this.getTextResult());
                  this.parameter.SearchCriteria = '';
               }else{
                  this.$emit('getCodeConditionOK', this.getTextResult());
                  this.$emit('input',this.getTextResult());
                  this.parameter.SearchCriteria = '';
               }
               
            } else {
                this.$emit('getCancel');
                this.ResetProps();
            }
        }
      },
    emitEventOK(){      
      this.clickOK = true
      },

    RowClicked(item){ 
        if(item.selected){      
          this.$set(item, 'selected', false); 
        }else{
          this.$set(item, 'selected', true);  
        }
        EventBus.$emit('rowClicked', item);
    },

    showListing(show) {
        this.isEditMode = show ? false : true;
        this.isListing = show ? true : false;
      },

      ResetProps(){
        this.parameter.SearchCriteria = '';
        this.showListing(true);
      },

    async SearchAssessment(){
      this.isLoading = true;
      this.parameter.PageNumber = this.currentPage;       
      this.parameter.PageSize = this.perPage;
      await AssessmentService.getAll(this.parameter)
        .then((response) => {
          if(response.status == '200' && response.data){
            this.items = response.data;

          if (this.items.length === 0) {
            this.ShowMessageIsEmpty = true;                      
          }
            this.isLoading = false;    
            if(response.data.length > 0){                        
              this.items.forEach(function(element) { 
                element.selected = false;          
                if (element.assessmentDate) element.assessmentDate = Utils.formatterDateToString(element.assessmentDate);  
                if (element.assessmentTime) element.assessmentTime = Utils.formatTime(element.assessmentTime);        
                if (element.sysDate) element.sysDate =  Utils.formatterDateToString(element.sysDate);           
            });
            let headerString = response.headers["x-pagination"];
            this.Header = JSON.parse(headerString);
            this.totalRows = this.Header.TotalCount;
            }

            if(this.items.length > 0 && this.isSelectFirst){          
              setTimeout(() => this.$refs.PainAssesmentTable.selectRow(0), 300);
              this.isSelectFirst = false;
            }
          } 
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
            if (!error.response) {
              this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
            } else {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        }); 
    },

    ChangeDropDownTherapistCode(item){
        this.painAssessment.therapistCode = item ? item.code : '';
    },

    ChangeDropDownCharacter(item){
        this.painAssessment.painCharacter = item ? item.value : '';
    },

    ChangeDropDownFrequency(item){
        this.painAssessment.frequency = item ? item.value : '';
    },

    OnChangeIntervention(){

    },

    async getAssessment(){
        await AssessmentService.get(this.recNo)
          .then((response) => { 
            if(response.data){   
              this.painAssessment = response.data;
              if(this.painAssessment.assessmentDate)
                this.painAssessment.assessmentDate = Utils.formatterDate(this.painAssessment.assessmentDate); 

                if(this.painAssessment.assessmentTime) 
                  this.painAssessment.assessmentTime = Utils.formatTimeHm(this.painAssessment.assessmentTime);
            }
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(this.$tc('Msg.Error'),error,"error");
            } 
          });  
      },

      showToast(titleKey, msgKey, variant = "success") {
        this.$bvToast.toast( msgKey, {
            title: titleKey,
            autoHideDelay: 4000,
            variant: variant
        });
      },

      onSignPassword(value) {
        this.showSignPassword = value;
      },

      onModalPasswordResult(result) {      
        if (result.status) {
          this.doingSave()
        } else {
          this.showMessage(this.$tc('Msg.Error'),result.message,"error");
        }
        this.showSignPassword = false;
      },

      onCodeDescriptionOk(result){
        this.Allergy.allergyCode = result.code;
        this.getLookupFieldsDesc(result.code);
      },

      formatterDate(value){
         return Utils.formatterDate(value);
      },

      SaveOrEdit(){
        this.pendingChanges = false;  
        this.SaveAssessment();        
      },

      async doingSave() {
        let data = {
          HeaderId:this.RecordId,
          TherapistCode:this.painAssessment.therapistCode,
          IsSigned:true,
          AssessmentDate:this.painAssessment.assessmentDate,
          AssessmentTime:this.painAssessment.assessmentTime ? Utils.getDefaultDate()+this.painAssessment.assessmentTime:null,
          PainIntensity:this.painAssessment.painIntensity,
          Location:this.painAssessment.location,
          PainCharacter:this.painAssessment.painCharacter,
          Duration:this.painAssessment.duration,
          Frequency:this.painAssessment.frequency,
          Intervention:this.painAssessment.interventionList,
          OtherIntervention:this.painAssessment.otherIntervention,
          InterventionTime:this.painAssessment.interventionTime,
          Notes:this.painAssessment.notes,
          PatientCode:this.PatientCode,          
        }
        await AssessmentService.Add(data)
        .then((response) => {
           if(response.status == '200'){   
                this.isListing = true;
                this.isEditMode = false;   
                this.isSelectFirst = true;
                this.SearchAssessment();
             setTimeout(() => 
                  this.showToast(
                    this.$t('Msg.Success'),
                    this.msg
                ), 1500); 
            }                           
        })
        .catch((error) => {
            if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });
      },

      async SaveAssessment(){ 
        let data = {
          HeaderId:this.RecordId,
          TherapistCode:this.painAssessment.therapistCode,
          IsSigned:this.painAssessment.isSigned,
          AssessmentDate:this.painAssessment.assessmentDate,
          AssessmentTime:this.painAssessment.assessmentTime ? Utils.getDefaultDate()+this.painAssessment.assessmentTime:null,
          PainIntensity:this.painAssessment.painIntensity,
          Location:this.painAssessment.location,
          PainCharacter:this.painAssessment.painCharacter,
          Duration:this.painAssessment.duration,
          Frequency:this.painAssessment.frequency,
          Intervention:this.painAssessment.interventionList,
          OtherIntervention:this.painAssessment.otherIntervention,
          InterventionTime:this.painAssessment.interventionTime,
          Notes:this.painAssessment.notes,
          PatientCode:this.PatientCode,          
        }
        if(this.isAdd){   
          if (!this.NoteOptions.requestPassword) {
            this.doingSave()
          } else {
            this.onSignPassword(true)
          }
        }else{
          AssessmentService.Update(this.recNo,data)
        .then((response) => {
           if(response.status == '200'){   
            this.isListing = true;
            this.isEditMode = false;   
            this.SearchAssessment();
             setTimeout(() => 
                  this.showToast(
                    this.$t('Msg.Success'),
                    this.msg
                ), 1500); 
            }                           
        })
        .catch((error) => {
            if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });
        }
       
      },

      ResetObj(){
        this.painAssessment.therapistCode = "";          
        this.painAssessment.isSigned = false;
        this.painAssessment.assessmentDate = null;
        this.painAssessment.assessmentTime = null;
        this.painAssessment.painIntensity = null;
        this.painAssessment.location = "";
        this.painAssessment.painCharacter = "";
        this.painAssessment.duration = "";
        this.painAssessment.frequency = "";
        this.painAssessment.interventionList = [];
        this.painAssessment.otherIntervention = "";
        this.painAssessment.interventionTime = null;
        this.painAssessment.notes = "";  
      },

    AddAssessment(){
       this.ResetObj();
       this.isAdd = true;
       this.showListing(false);
      // this.painAssessment.therapistCode = LocalStorage.getUserId()
       this.painAssessment.therapistCode = this.$store.state.employeeCode;
       this.getNoteOption()
       this.getDateTime()
       
    },

    RemoveAssessment(item){
      const RecordId = item.recNo
      this.$bvModal.msgBoxConfirm('This Assessment will be deleted permanently', {
        title: 'Delete Assessment',
        okTitle: this.$t('Shared.TitleDelete'),
        cancelTitle: this.$t('Shared.BtnCancel'),
        footerClass: 'p-2',
        titleClass: 'modal-title modal-type-warning'
      })
      .then(value => {
        if(value){
            AssessmentService.Delete(RecordId)
            .then(() => {
              this.SearchAssessment();
            })
            .catch((error) => {
              if (!error.response) {
                // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToDelete'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        }
      })
    },

    async EditAssessment(row){
      this.isAdd = false;
      this.recNo = row.recNo;
      this.showListing(false);
      await this.getAssessment();
      //this.painAssessment.therapistCode = this.painAssessment.therapistName 
    },

    onRowSelected(items) {    
     this.selected = items;
    },

    onFiltered(filteredItems){
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    pageChanged(page){
      this.currentPage = page;    
      this.SearchAssessment(); 
    },
    PerPageFunction(perpage){
      this.perPage = perpage;  
      this.SearchAssessment(); 
    }
  },

  created(){
  },

  async mounted(){
    this.SearchAssessment();
  }
   
};
</script>

<style scoped>
.modal-body{
  width: auto!important;
}
</style>